import { status } from '../utils';

export function getGroups(token){

  return fetch(`${process.env.REACT_APP_API_URL}/groups/`,{
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    },
  })
  .then(status)
}

export function getGroup(id, token){
  return fetch(`${process.env.REACT_APP_API_URL}/groups/${id}/`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    },
  })
  .then(status)
}

export function joinGroup(data){
  return fetch(`${process.env.REACT_APP_API_URL}/members/join/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(status)
}

export function leaveGroup(data){
  return fetch(`${process.env.REACT_APP_API_URL}/members/leave/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(status)
}


export function getGroupComments(token, group, { limit = 5, offset = 0, lastSeen } = {}){
  const params = new URLSearchParams({ group, limit, offset });
  if (lastSeen !== undefined && lastSeen !== null) params.append('last_seen', lastSeen);
  return fetch(`${process.env.REACT_APP_API_URL}/comments/by_group/?${params.toString()}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    },
  })
  .then(status)
}

export function postComment(token, description, group, user){
  return fetch(`${process.env.REACT_APP_API_URL}/comments/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    },
    body: JSON.stringify({description, group, user})
  })
  .then(status)
}